import { InputAdornment, TextField } from "@mui/material";
import { Icon } from "@src/appV2/redesign/components/Icon";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ChangeEvent, type KeyboardEvent, type RefObject } from "react";

import { getShortcutHint } from "./KeyboardHints";

interface OmnisearchInputProps {
  value: string;
  inputRef: RefObject<HTMLInputElement>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
}

export function OmnisearchInput(props: OmnisearchInputProps) {
  const { value, inputRef, onChange, onKeyDown } = props;

  return (
    <TextField
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      fullWidth
      inputRef={inputRef}
      placeholder="Search professionals, workplaces..."
      value={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon size="large" sx={{ color: "text.secondary" }} type="magnifying-glass" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <Text
              inline
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                backgroundColor: theme.palette.action.hover,
                border: `1px solid ${theme.palette.divider}`,
                paddingX: 2,
                paddingY: "2px",
                borderRadius: theme.borderRadius?.xSmall,
                fontFamily: "monospace",
                lineHeight: 1.4,
              })}
              variant="caption"
            >
              {getShortcutHint()}
            </Text>
          </InputAdornment>
        ),
        sx: (theme) => ({
          paddingY: 3,
          paddingX: 3,
          gap: 2,
          borderRadius: theme.borderRadius?.medium,
          fontSize: theme.typography.body1.fontSize,
          "& fieldset": { border: "none" },
        }),
      }}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
  );
}
